import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import {
  Button,
  Col,
  FormControl,
  HelpBlock,
  PageHeader,
  Panel,
  Row,
} from 'react-bootstrap'

import { FormField } from 'internal-components/src/components/Form'
import Icon from 'internal-components/src/components/Icon'
import {
  OfferFilterDataRecord,
  SignupWithExternalsRecord
} from 'internal-components/src/records'
import { makeSelectOffers } from 'internal-components/src/redux/modules/product/selectors'

import createSignupProgress, {
  SignupProgressRecord,
} from '../../records/SignupProgress'
import * as signupActions from '../../redux/modules/signupEdit/actions'
import {
  selectErrorsByPath,
  selectEditSignupWithExternals,
} from '../../redux/modules/signupEdit/selectors'

import ServiceDetail from '../../components/Signup/ServiceDetail'
import ServiceOptions, { shouldShowOptions, handleSubmitOptions } from '../../components/Signup/ServiceDetail/ServiceOptions'
import PartnerConfirmation from '../../components/Signup/PartnerConfirmation'
import ProgressSummary from '../../components/Signup/ProgressSummary'

function empty(val) { return val === '0' || !val; }

import './DetailView.css'
import AppointmentDateTimeField from "../../../deps/internal-components/src/components/Form/AppointmentDateTimeField";

export class DetailView extends React.Component {
  handleSubmit(e) {
    e.preventDefault()

    const { offer, product, signup } = this.props.signupWithExternals;
    const { advanceToSummary, setData, setExtraOfferId, signupEditMeta } = this.props;

    if (shouldShowOptions(product, offer, signup)) {
      if (!this.validateServiceOptions()) {
        console.log('client-side validation failed')
        return;
      }
    }

    handleSubmitOptions(this.props.signupWithExternals, signupEditMeta, setData, setExtraOfferId);

    advanceToSummary();
  }

  render() {
    const {
      errors,
      partnerApproved,
      setCustomerReference,
      setData,
      setPartnerApproved,
      setPreferredAppointmentDate,
      setPreferredAppointmentTime,
      setSiteContactFirstName,
      setSiteContactLastName,
      setSiteContactNumber,
      signupProgress,
      signupWithExternals,
      setServicePassword,
      working
    } = this.props;

    const signup = signupWithExternals.signup
    const offer = signupWithExternals.offer
    const partner = signupWithExternals.partner
    const product = signupWithExternals.product;
    const appointmentRequired = product.type === 'VDSL';

    return (
      <section className="container">
        <PageHeader>
          {signup.reference && (
            <small className="pull-right">{signup.reference}</small>
          )}
          Service Details
        </PageHeader>

        <ProgressSummary
          signupProgress={signupProgress}
          signupWithExternals={signupWithExternals}
        />

        <form onSubmit={this.handleSubmit.bind(this)} noValidate>
          {partner &&
            !partner.attributes.has('invisible') && (
              <PartnerConfirmation
                errors={errors}
                partnerApproved={partnerApproved}
                setPartnerApproved={setPartnerApproved}
                signupWithExternals={signupWithExternals}
              />
            )}

          <Row>
            <Col md={12}>
              <ServiceDetail
                errors={errors}
                product={product}
                setData={setData}
                signup={signup}
                setServicePassword={setServicePassword}
              />
            </Col>
          </Row>

          {shouldShowOptions(product, offer, signup) && <Panel>
            <Panel.Body>
              <ServiceOptions receiveDoValidate={(fn) => this.validateServiceOptions = fn} />
            </Panel.Body>
          </Panel>}

          <Row>
            <Col md={12}>
              <h4>Customer Reference</h4>

              <FormField
                bsSize="large"
                controlId="customerReference"
                controlLabel="Service Reference"
                errors={errors}
                value={signup.get('customerReference') || ''}
              >
                <FormControl
                  onChange={e => setCustomerReference(e.target.value)}
                  placeholder="Service Reference"
                  type="text"
                  value={signup.get('customerReference') || ''}
                />

                <HelpBlock>
                  If you have multiple services with us then you can use this field to set a "nickname".
                  We will put these nicknames on your invoices to help you identify your services.
                </HelpBlock>
              </FormField>
            </Col>
          </Row>

          {product.addressRequired && <div>
            <h4>Site Contact</h4>

            <p>
              As this service potentially requires a site visit, we need the
              details of someone who will be present at the site for the
              installation.
            </p>
            <Row>
              <Col md={6}>
                <FormField
                  bsSize="large"
                  controlId="siteContactFirstName"
                  controlLabel="Contact First Name"
                  errors={errors}
                  onChange={e => setSiteContactFirstName(e.target.value)}
                  required
                  value={signup.get('siteContactFirstName') || ''}
                />

                <FormField
                  bsSize="large"
                  controlId="siteContactLastName"
                  controlLabel="Contact Last Name"
                  errors={errors}
                  onChange={e => setSiteContactLastName(e.target.value)}
                  required
                  value={signup.get('siteContactLastName') || ''}
                />

                <FormField
                  bsSize="large"
                  controlId="siteContactNumber"
                  controlLabel="Contact Number"
                  errors={errors}
                  onChange={e => setSiteContactNumber(e.target.value)}
                  required
                  value={signup.get('siteContactNumber') || ''}
                />
              </Col>
              {appointmentRequired &&
                <Col md={6}>
                  {/*<AppointmentDateTimeField
                    date={signup.get('preferredAppointmentDate')}
                    time={signup.get('preferredAppointmentTime')}
                    onDateChange={setPreferredAppointmentDate}
                    onTimeChange={setPreferredAppointmentTime}
                    errors={errors}
                  />*/}
                  <p><strong>Installation and Appointment</strong></p>

                  <p>
                    Vision Network, the carrier of G.fast, will schedule your appointment in the next 2-10 working
                    days between 8am-12pm (AM) or 12-5pm (PM). We will update you of your appointment via email
                    and if you are not available of this appointment please reply to the email and we will attempt
                    to reschedule the appointment for a suitable day. The technician will call you 15-30mins before
                    arriving and the installation will take between 30mins to 2 hours depending on what is required.
                  </p>
                </Col>}
            </Row>
          </div>}

          <Row>
            <Col md={12}>
              <Button bsSize="large" type="submit" disabled={working}>
                Continue <Icon name="long-arrow-right" spin={working} />
              </Button>
            </Col>
          </Row>
        </form>
      </section>
    )
  }
}

DetailView.propTypes = {
  advanceToSummary: Pt.func.isRequired,
  errors: Ipt.map.isRequired,
  voipOffers: Pt.instanceOf(OfferFilterDataRecord).isRequired,
  partnerApproved: Pt.bool.isRequired,
  setCustomerReference: Pt.func.isRequired,
  setData: Pt.func.isRequired,
  setExtraOfferId: Pt.func.isRequired,
  setNeedsVoice: Pt.func.isRequired,
  setPartnerApproved: Pt.func.isRequired,
  setSiteContactFirstName: Pt.func.isRequired,
  setSiteContactLastName: Pt.func.isRequired,
  setSiteContactNumber: Pt.func.isRequired,
  setUseExistingNumber: Pt.func.isRequired,
  signupEditMeta: Ipt.map.isRequired,
  signupProgress: Pt.instanceOf(SignupProgressRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
  setServicePassword: Pt.func.isRequired,
  working: Pt.bool.isRequired,
}

const mapStateToProps = state => {
  const signupWithExternals = selectEditSignupWithExternals(state, {
    sortBy: null,
  })

  return {
    errors: selectErrorsByPath(state.signupEdit),
    voipOffers: makeSelectOffers()(state, {filter: {upgradeGroup: 'VOIP'}}),
    partnerApproved: state.signupEdit.getIn(['meta', 'partnerApproved']),
    signupProgress: createSignupProgress(
      signupWithExternals,
      state.signupEdit.get('errors'),
      'detail',
    ),
    signupEditMeta: state.signupEdit.get('meta'),
    signupWithExternals,
    working: state.signupEdit.getIn(['meta', 'working']),
  }
}

export default connect(
  mapStateToProps,
  signupActions,
)(DetailView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/DetailView.jsx